export let HubInterestOption;

(function (HubInterestOption) {
  HubInterestOption["Sales"] = "sales";
  HubInterestOption["Marketing"] = "marketing";
  HubInterestOption["CustomerService"] = "customer-service";
  HubInterestOption["CMS"] = "cms";
  HubInterestOption["GeneralOverview"] = "general-overview";
  HubInterestOption["Operations"] = "operations";
})(HubInterestOption || (HubInterestOption = {}));